import React from 'react'
import { RegistrationFormRouter } from './components/RegistrationFormRouter/RegistrationFormRouter'
import { Wrapper } from '../Wrapper/Wrapper'
import { SocialNetworks } from '../../emun/social'

interface IRegistrationFormProps {
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string): void
}

export const RegistrationForm: React.FC<IRegistrationFormProps> = ({ onSocialAuth }) => (
  <Wrapper>
    <RegistrationFormRouter onSocialAuth={onSocialAuth} />
  </Wrapper>
)
RegistrationForm.displayName = 'RegistrationForm'
